var angular = require('angular');
var _module = angular.module('benoit');

_module.factory('$lighapi', [
    '$log',
    '$rootScope',
    '$http',
    '$q',

    function $lighapi($log, $rootScope, $http, $q) {
        function LighAPI(){}

        /**
         * Search by address or url
         *
         * @function search
         * @param {Object} options
         * @param {String} lid - listingId
         * @param {String} [address] - You must pass either address or url
         * @param {String} [url] - You must pass either address or url
         * @param {String} [listingstatus] - The current listing status
         */
        LighAPI.prototype.search = function search(options) {
            var deferredAbort = $q.defer();
            var promise = $http.get('/v1/thirdparty/lighapi/search', {
                params: options,
                timeout: deferredAbort.promise
            })
            .then(function onSearchResponse(response) {
                return response.data;
            })
            .catch(function onSearchError(err) {
                $log.error('$lighapi -> search -> Error', err);

                return false;
            });

            promise.abort = function abort() {
                deferredAbort.resolve();
            };

            promise.finally(function () {
                promise.abort = angular.noop;
            });

            return promise;
        };


        return new LighAPI();
    }
]);
